module.exports = __webpack_public_path__ + "img/20180815_151844_211.c2a6c16a.jpg";